export default "__VITE_ASSET__D1jB6NCA__"